// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__wQULv","icon":"Skill_icon__I6jpG","fontIcon":"Skill_fontIcon__RAs1I"};